import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

const defaultFilterState = {
   riksavvägningen: true,
   sweref: true,
   rix95: true,
   förstörda: false,
}

export default createReducer(defaultFilterState, {

    [actions.TOGGLE_FILTER]: (state, action) => ({
    	...state, 
    	[action.filter]: !state[action.filter]
    })

})


// WEBPACK FOOTER //
// ./src/reducers/filter.js